import React, { useState } from 'react';
import { Icon } from '../../components/Icon';
import { usePerson } from '../../hooks/usePersonas';
// import { useDebounce } from '../../hooks/useDebounce';
// import type { EmpleadoFilters } from '../../types/empleado';
import { UserFormCard } from '../../components/UserFormCard';
import { Table } from './Table';

const Users: React.FC = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    // const [filters, setFilters] = useState<EmpleadoFilters>({});
    //   const [showFilters, setShowFilters] = useState(false);
    const [personType] = useState("1");

    // const debouncedSearch = useDebounce(searchTerm, 300);
    // Parametros para agregar nuevo empleado
    const [showUserForm, setShowUserForm] = useState(false);

    const handleOpenForm = () => {
        setShowUserForm(prev => !prev);
    };

    const handleCloseForm = () => {
        setShowUserForm(false);
    };


    const {
        data: users,
        loading,
        error,
        total,
        totalPages,
        refetch,
        // search,
        updateStatus,
        createPersonComplete,
        updating,
        creating
    } = usePerson({
        tipo_persona_id: personType,
        page: currentPage,
        pageSize
    });

    // Reset page when search or filters change
    // useEffect(() => {
    //     setCurrentPage(1);
    // }, [debouncedSearch, filters]);

    const handleSearchPage = () => {
        setCurrentPage(1);

    }



    //   const handleFilterChange = (newFilters: Partial<EmpleadoFilters>) => {
    //     setFilters(prev => ({ ...prev, ...newFilters }));
    //   };

    // const clearFilters = () => {
    //   setFilters({});
    //   setSearchTerm('');
    //   setShowFilters(false);
    // };

    if (error) {
        return (
            <div className="space-y-6 animate-fade-in">
                <div className="flex items-center justify-between">
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                        Gestión de Visitas
                    </h2>
                </div>
                <div className="card p-6 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800">
                    <div className="flex items-center">
                        <Icon name="alert-circle" className="w-5 h-5 text-red-500 mr-2" />
                        <span className="text-red-700 dark:text-red-300">
                            Error al cargar las visitas: {error}
                        </span>
                    </div>
                    <button
                        onClick={refetch}
                        className="mt-3 btn-primary"
                    >
                        Reintentar
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-6 animate-fade-in">
            {/* Header */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
                <div>
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                        Gestión de Usuarios
                    </h2>
                    <p className="text-gray-600 dark:text-gray-400 mt-1">
                        {total} usuarios encontradas
                    </p>
                </div>
                <div className="flex items-center space-x-3">

                    <button
                        onClick={handleOpenForm}
                        className={`flex items-center px-4 py-2 text-sm font-medium text-white ${showUserForm ? "bg-red-400 hover:bg-red-500" : "bg-blue-600 hover:bg-blue-700"}  rounded-lg  transition-colors`}
                    >
                        {showUserForm ? (
                            <>
                                <Icon name="close" className="w-4 h-4 mr-2" />
                                Cancelar
                            </>
                        ) : (
                            <>
                                <Icon name="plus" className="w-4 h-4 mr-2" />
                                Nuevo Usuario
                            </>
                        )}

                    </button>
                </div>
            </div>

            {/* Componente hijo - Card del formulario */}
            <UserFormCard
                creating={creating}
                isVisible={showUserForm}
                onClose={handleCloseForm}
                onSubmit={createPersonComplete}
            />

            {/* Filtros y búsqueda */}
            <div className="card p-6">
                <div className="flex flex-row space-x-2 lg:flex-row lg:items-center lg:justify-start space-y-4 lg:space-y-0">
                    {/* Buscador */}
                    <div className="flex-1 max-w-md">
                        <div className="relative">
                            <Icon name="search" className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                            <input
                                type="text"
                                placeholder="Buscar por nombre..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                            />
                        </div>
                    </div>
                    <div>
                        <button
                        onClick={handleSearchPage}
                            className={`flex items-center mx-auto px-3 py-2 border dark:hover:bg-gray-700 dark:bg-gray-600 dark:text-white border-gray-500 text-sm font-medium rounded-lg transition-colors`}
                        >
                            <Icon name="search" className="w-4 h-4 mr-1" />
                            Buscar
                        </button>
                    </div>

                </div>

            </div>

            {/* Tabla de empleados */}
            <Table
                data={users}
                loading={loading}
                currentPage={currentPage}
                totalPages={totalPages}
                pageSize={pageSize}
                total={total}
                onPageChange={setCurrentPage}
                onRefresh={refetch}
                onStateChange={updateStatus}
                updating={updating}
            />
        </div>
    );
};

export default Users;